(ns css.core
  (:require
    ;; require cljss.reagent so that it's brough into the project on the cljs
    ;; side-- without this, any macro-emitted code (via defstyled) will be using
    ;; undefined variables cljss.reagent/<vars> because the cljs runtime didnt
    ;; declare a dependency, meaning the clsoure compiler didnt bundle the lib.
    [cljss.core :as cljss]
    [cljss.reagent]
    [oops.core :refer [oset!]]

    [cljss.sheet :as sheet :refer [ISheet insert! flush! filled?]]
    [goog.object :as gobj]
    [goog.dom :as dom]
    [runtime.core :refer [DEBUG ie11?]]
    [css.ie11 :as ie11]
    )

  (:require-macros
    [logging.core :refer [error]]
    ;; include all the styling macros from our .clj namespace so that they're
    ;; properly linked to our cljs namespace, meaning consumers only have to
    ;; require our css.core, and not css.core :refer-macros [...]. likewise we
    [css.core :refer [defstyled embed-svg]]))

; (class-names "foo" "bar" :bax { :active true :seleced false })
; -> "foo bar bax active"
; (class-names "foo" "bar" nil)
; -> "foo bar"
; (class-names "foo" "bar" :bax { :active true :seleced false } 'nox { :more-classes-in-map true })
; -> "foo bar bax active nox more-classes-in-map"
(defn class-names [& args]
  (clojure.string/join " "
    (mapv name
      (reduce (fn [arr arg]
               (cond
                 (or (string? arg)
                     (symbol? arg)
                     (keyword? arg)) (conj arr arg)
                 (vector? arg) (vec (concat arr arg))
                 (map? arg) (vec (concat arr
                                   (reduce-kv (fn [map-arr key value]
                                               (if (true? value)
                                                 (conj map-arr key)
                                                 map-arr)) [] arg)))
                 :else arr)) [] args))))

;; export a ref to cljss so things like ::css/media work without
;; having to require the cljss.core namespace.
(def media ::cljss/media)

;; on the dom
;; :root {
;;   --var-theme-primary: #hex;
;;   --var-theme-secondary #hex;
;;   --var-theme-tertiary #hex;
;; }
(def var-prefix "--var-theme-")

(defn- theme-map->css [m]
  (let [css-rules (reduce
                    (fn [s [k v]] (str s var-prefix (name k) ": " v ";"))
                    ""
                    m)]
    (str ":root {" css-rules "}")))

(defn set-theme!
  "Color themes are set via primary/secondary/tertiary colors on components as
  css-vars. Setting a theme is merely changing the value of the three vars on
  the dom."
  [theme]
  (oset! (.getElementById js/document "themes") "innerHTML" (theme-map->css theme)))

(defn get-theme [ary]
  (str "var(" var-prefix (name ary) ")"))

;; START OF IE11 Hacks:

;; IMPORTANT: if we ever get more than this many rules in a single stylesheet,
;; our ie11 hack will break. this is because the cljss internals will create
;; another sheet, but we don't have a way to make sure the sheet they create
;; is one of our sheet implementations, it will use the defaults :(
;; https://stackoverflow.com/questions/9906794/internet-explorers-css-rules-limits
(def limit 65534)

;; the intent here is to provide our own protocol-compliant version of a Sheet
;; for cljss. unfortunately, cljss doesn't provide a way for us to ever hand
;; over this deftype in a constructor, etc.. instead we're going to hook into
;; any implementation code which might create/modify sheets (stored inside
;; cljss.core/sheets as an atom).
(deftype Sheet [tag sheet cache]
  ISheet
  (insert! [this rule' cls-name]
    (when (filled? this)
      (error (js/Error. (str "A stylesheet can only have " limit " rules"))))

    (when-not (@cache cls-name)
      (swap! cache conj cls-name)
      (let [rule (if (ifn? rule') (rule') rule')
            rules-count (gobj/get (gobj/get sheet "cssRules") "length")]
        ;; only need to do this for ie11
        (when (ie11?)
          ;; only rule fns have vars
          (when (ifn? rule') (ie11/swap-vars rule cls-name)))
        ;; for some reason fast-insert via insertRule doesn't work for
        ;; cljss/media queries... *shrug*... for now just disable fast insert
        (if true
          (dom/appendChild tag (dom/createTextNode rule))
          (try
            (.insertRule sheet rule rules-count)
            (catch :default e
              (when DEBUG
                (js/console.warn "Illegal CSS rule" rule))))
          ))))

  (flush! [this]
    (-> tag
        .-parentNode
        (.removeChild tag)))

  (filled? [this]
    (>= (count @cache) limit)))

(defn create-sheet []
  (let [tag (sheet/make-style-tag)
        sheet (gobj/get tag "sheet")]
    (.setAttribute tag "data-cljss-managed-sheet" 0)
    (Sheet. tag sheet (atom #{}))))

(defn init-stylesheets []
  ;; cljss exposes a type and protocol, but no way to override it... so
  ;; we're going to get into their implementation (gross) and provide our
  ;; own Sheet impl
  (reset! cljss.core/sheets (list (create-sheet)))
  (when (ie11?) (ie11/polyfill!)))

(defn remove-styles! []
  (run! flush! @cljss/sheets)
  (reset! cljss/sheets (list (create-sheet))))

